import Image from 'next/image'
import LoginSlider1 from '../../assets/images/LoginSlide1.png'
import LoginSlider2 from '../../assets/images/LoginSlide2.png'
import LoginSlider3 from '../../assets/images/LoginSlide3.png'
import LoginSlider4 from '../../assets/images/LoginSlide4.png'
import DDRCLoginSlider2 from '@/assets/images/DDRCLoginSlide2.png'
import DDRCLoginSlider3 from '@/assets/images/DDRCLoginSlide3.png'

import { Pagination, Autoplay } from 'swiper/modules'

import { Swiper, SwiperSlide } from 'swiper/react'

const LoginSlider = () => {
  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      slidesPerView={1}
      autoplay
      pagination={{ clickable: true }}
      className="login_swiper"
    >
      <SwiperSlide>
        <div>
          <Image
            src={LoginSlider1}
            alt="login slider 1"
            className="w-full h-[280px] object-contain mb-6"
          />
          <h3 className="text-heading-sm text-primary text-center">
            India’s largest diagnostics company
          </h3>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div>
          <Image
            src={DDRCLoginSlider2}
            alt="login slider 2"
            className="w-full h-[280px] object-contain mb-6"
          />
          <h3 className="text-heading-sm text-primary text-center">
            India’s largest diagnostics company
          </h3>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div>
          <Image
            src={DDRCLoginSlider3}
            alt="login slider 3"
            className="w-full h-[280px] object-contain mb-6"
          />
          <h3 className="text-heading-sm text-primary text-center">
            India’s largest diagnostics company
          </h3>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div>
          <Image
            src={LoginSlider4}
            alt="login slider 4"
            className="w-full h-[280px] object-contain mb-6"
          />
          <h3 className="text-heading-sm text-primary text-center">
            India’s largest diagnostics company
          </h3>
        </div>
      </SwiperSlide>
    </Swiper>
  )
}

export default LoginSlider
